import styled from "styled-components";

export const Heading = styled.div`
  text-align: center;
  color: #000;
  font-family: Poppins;
  font-size: 1.125em;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 1.7em;
`;
export const Input = styled.input`
  width: 19.5em;
  height: 2.5em;
  margin-bottom: 0.9em;
  border-radius: 0.5em;
  border: 1px solid #8e8e8e;
  background: #fff;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0.5em 0.94em;
  ::placeholder {
    color: #c8c8c8;
    font-family: Poppins;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
export const Image = styled.div`
  margin: 0 auto;
   display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const Edit = styled.div`
  width: 1.125rem;
  height: 1.125rem;
  position: absolute;
  right: 1.69em;
  top: 0.88em;
  cursor: pointer;
  @media (max-width: ${({ theme }) => theme.mobile.lg}) {
    right: 1em;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    right: 1.69em;
  }
`;
export const Important = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5em;
  justify-content: space-between;
  padding-right: 0.44em;
  p {
    color: #666;
    font-family: Poppins;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-right: 1em;
  }
  input[type="checkbox"] {
    display: none;
  }
  .button {
    width: 1.8125rem;
    height: 0.6875rem;
    flex-shrink: 0;
    border-radius: 0.625rem;
    background: #e3e3e3;
    position: relative;
    cursor: pointer;
  }
  .button::before {
    content: "";
    position: absolute;
    width: 1.375rem;
    height: 1.375rem;
    flex-shrink: 0;
    border-radius: 50%;
    background: #8e8e8e;
    top: -0.31em;
    left: -0.31em;
    transition: 0.3s;
  }

  input:checked + .button::before {
    background: #c103c6;
    transform: translateX(1.125rem);
  }
`;
export const ImageContainer = styled.div`
  width: 19.625rem;
  height: 12.5625rem;
  flex-shrink: 0;
  border-radius: 1.125rem;
  background: #f4f4f4;
  margin-bottom: 1.94em;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
